import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SyncService } from "../../sync.service";
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
	selector: 'create-deal',
	templateUrl: './create-deal.component.html',
	styleUrls: ['./create-deal.component.css'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('fadeIn', [
			transition(':enter', [
				style({ opacity: 0}),
				animate('125ms ease-in', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0}))
			])
		]),
		trigger('fadeInUp', [
			transition(':enter', [
				style({ opacity: 0, transform: 'translateY(-2px)' }),
				animate('125ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0, transform: 'translateY(2px)' }))
			])
		])
	]
})
export class CreateDealComponent implements OnInit {

	maxedOut = false;
	constructor(
		private syncService: SyncService,
	) {}

	// page ='';

	dealName = '';
	dealNameInvalid = false;
	dealNameInvalidText = '';

	fundName = '';
	fundNameInvalid = false;
	fundNameInvalidText = '';

	fundTypes = [
		'PE Fund',
		'VC Fund',
		'Credit Fund',
		'Fund of Funds',
		'Hybrid Investment Fund',
	];
	fundType: string = '';
	fundInvalid = false;

	receivedDate = '';
	receivedDateInvalid = false;

	deadlineDate = '';
	deadlineDateInvalid = false;

	pricingReferenceDate = '';
	pricingReferenceDateInvalid = false;

	userData = null;
	deals: any = [];

	ngOnInit(): void {

		if (this.syncService.authStatus.getValue() !== 'authenticated') {
			this.syncService.updateAuthStatus('unauthenticated');
			this.syncService.updatePage('login');
			return;
		}

		// this.syncService.page$.subscribe((data: string) => {
		// 	this.page = data;
		// 	console.log('this.page', this.page);
		// });

		this.syncService.userData$.subscribe((data: any) => {
			this.userData = data;
			if (this.userData) {

				// @ts-ignore

				this.deals = this.userData['Deals'];

				// if (this.deals && this.deals.length >= 10) {
				// 	this.maxedOut = true;
				// }

				// this.displayDeals = this.deals;
				// for (let i = 0; i < this.deals.length; i++) {
				// 	this.deals[i]['Files'].forEach((file: any) => {
				// 		this.displayFiles.push(file);
				// 	});
				// }
			}
		});
	}

	onKeyUpDealName($event: any) {
		this.dealName = ($event.target as HTMLInputElement).value;
		this.validateDealName();
	}

	validateDealName() {
		this.dealNameInvalid = false;
		if (!this.dealName) {
			this.dealNameInvalid = true;
			this.dealNameInvalidText = 'Fund name cannot be empty.';
		}
		if (this.dealName.includes('/')) {
			this.dealNameInvalid = true;
			this.dealNameInvalidText = 'Fund name cannot contain a forward slash.';
		}
		this.deals.forEach((deal: any) => {
			if (deal['Deal Name'] === this.dealName) {
				this.dealNameInvalid = true;
				this.dealNameInvalidText = 'Fund name already exists.';
			}
		});
	}

	onKeyUpFundName($event: any) {
		this.fundName = ($event.target as HTMLInputElement).value;
		this.validateFundName();
	}

	validateFundName() {
		this.fundNameInvalid = false;
		if (!this.fundName) {
			this.fundNameInvalid = true;
			this.fundNameInvalidText = 'Fund name cannot be empty.';
		}
	}

	onSelectFundType($event: any) {
		this.fundType = $event.target.value;
		this.validateFundType();
	}

	validateFundType() {
		this.fundInvalid = !this.fundType;
	}

	onSelectReceivedDate($event: any) {
		const date = new Date($event[0]);
		this.receivedDate = date.toISOString().split('T')[0];
		this.validateReceivedDate();
		console.log(this.receivedDate);
	}

	validateReceivedDate() {
		this.receivedDateInvalid = !this.receivedDate;
	}

	onSelectDeadlineDate($event: any) {
		const date = new Date($event[0]);
		this.deadlineDate = date.toISOString().split('T')[0];
		this.validateDeadlineDate();
		console.log(this.deadlineDate);
	}

	validateDeadlineDate() {
		this.deadlineDateInvalid = !this.deadlineDate;
	}

	onSelectPricingReferenceDate($event: any) {
		const date = new Date($event[0]);
		this.pricingReferenceDate = date.toISOString().split('T')[0];
		this.validatePricingReferenceDate();
		console.log(this.pricingReferenceDate);
	}

	validatePricingReferenceDate() {
		this.pricingReferenceDateInvalid = !this.pricingReferenceDate;
	}

	onCreateDeal($event: any) {

		if (!$event) {
			return;
		}

		this.validateDealName();
		this.validateFundType();
		this.validateReceivedDate();
		this.validateDeadlineDate();
		this.validatePricingReferenceDate();

		if (!this.dealNameInvalid && !this.fundNameInvalid && !this.fundInvalid) {
			console.log('Creating deal...');
			this.syncService.updateCurrentDeal(this.dealName);
			this.deals.unshift({
				'Deal Name': this.dealName,
				'Fund Name': this.fundName,
				'Fund Type': this.fundType,
				'Received Date': this.receivedDate,
				'Deadline Date': this.deadlineDate,
				'Pricing Reference Date': this.pricingReferenceDate,
				'Files': [],
			});
			// @ts-ignore
			this.userData['Deals'] = this.deals;
			this.syncService.updateUserData(this.userData); // ON CREATE DEAL
			this.syncService.updatePage('funds');
		}
	}
}
